import React, { useEffect, useState } from 'react';

const CopyToDay = (props) => {

  const [copyFrom, setCopyFrom] = useState(1);
  const [days, setDay] = useState([]);

  useEffect(() => {

    if(props.copyFrom){
      setCopyFrom(props.copyFrom)
    }

    if(props.totalDays){
      const daysArray = Array.from({ length: props.totalDays }, (_, i) => `Day ${i + 1}`);
      setDay(daysArray);
    }
  },[props])

  return(
    <div className='copy-to-day-container slideTopToBottom '>
      <p className='flex-item' style={{fontWeight:"700"}}>Copy To</p>
      <div className='d-flex-wrap m-t-12'>
        {
          days.filter((_, index) => index !== copyFrom).map((day, index) => {
            return(
              <div onClick={()=>props.CopyContentToDay(day.slice(3,5) - 1)} className='d-flex flex-item copy-to-day m-r-8 m-b-8'>
                <p className='flex-item'>{day}</p>
              </div>
            )
          })
        }
      </div>
    </div>
  )
}

export default CopyToDay;